/**
 * @module common/utils/dom/dom-utils
 */

/**
 * @typedef {Object} ElementOffsets
 * @property {Number} top - Верхняя точка элемента
 * @property {Number} right - Правая точка элемента
 * @property {Number} bottom - Нижняя точка элемента
 * @property {Number} left - Левая точка элемента
 * @property {Number} cx - Центральная точка элемента по оси X
 * @property {Number} cy - Центральная точка элемента по оси Y
 */

/**
 * @hideconstructor
 * @classdesc Содержит различные утилиты DOM
 */
class DOMUtils {
  /**
   * @method
   * @description Получает текущую позицию элемента во viewport-е
   * @param {HTMLElement} el - Элемент
   * @returns {module:common/utils/dom/dom-utils~ElementOffsets}
   */
  static getElementDocumentPosition(el) {
    const rect = el.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const offsets = {
      top: rect.top + scrollTop,
      right: rect.left + scrollLeft + rect.width,
      bottom: rect.top + scrollTop + rect.height,
      left: rect.left + scrollLeft,
      cy: rect.top + scrollTop + rect.height / 2,
      cx: rect.left + scrollLeft + rect.width / 2,
    };
    return offsets;
  }

  /**
   * @method
   * @description Получает значение указанного стиля элемента
   * @param {HTMLElement} elem - Элемент
   * @param {Style} style - Название стиля
   * @returns {String}
   */
  static getStylePropertyValue(elem, style) {
    return window.getComputedStyle(elem, null).getPropertyValue(style);
  }

  /**
   * @member {Number}
   * @readonly
   * @description Ширина скроллбара клиента
   */
  static get scrollbarWidth() {
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.width = '100px';
    outer.style.msOverflowStyle = 'scrollbar';
    document.body.appendChild(outer);
    const widthNoScroll = outer.offsetWidth;
    outer.style.overflow = 'scroll';
    const inner = document.createElement('div');
    inner.style.width = '100%';
    outer.appendChild(inner);
    const widthWithScroll = inner.offsetWidth;
    outer.parentNode.removeChild(outer);
    return widthNoScroll - widthWithScroll;
  }
}

export default DOMUtils;
